import { type FC } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * CVs page has been unified with the Talent Pool.
 * This component redirects to the unified page for backward compatibility.
 */
const CvsTable: FC = () => {
  return <Navigate to="/dashboard/recruitment/talent-pool" replace />;
};

export default CvsTable;
